module.exports = __webpack_public_path__ + "static/media/btn2.55b63402.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/btn2.png
// module id = 982
// module chunks = 0